/**
 * @generated SignedSource<<52041ca5235fee605ffeb803f11c045e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type userRevokeZoomAuthMutation$variables = {
  userId: string;
};
export type userRevokeZoomAuthMutation$data = {
  readonly revokeZoomAccess: {
    readonly details: {
      readonly " $fragmentSpreads": FragmentRefs<"userProfileDetailFragment">;
    };
  };
};
export type userRevokeZoomAuthMutation = {
  variables: userRevokeZoomAuthMutation$variables;
  response: userRevokeZoomAuthMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userRevokeZoomAuthMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RevokeZoomAccessPayload",
        "kind": "LinkedField",
        "name": "revokeZoomAccess",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfileDetailConnect",
            "kind": "LinkedField",
            "name": "details",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "userProfileDetailFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userRevokeZoomAuthMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RevokeZoomAccessPayload",
        "kind": "LinkedField",
        "name": "revokeZoomAccess",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfileDetailConnect",
            "kind": "LinkedField",
            "name": "details",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "roleId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profileInformation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profileSettings",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultSessionPassword",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "zoomDetails",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientLocations",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preferredVideoType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "googleCalendarSync",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signedAgreement",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "setupCompletedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CategorisedSpecialities",
                "kind": "LinkedField",
                "name": "specialities",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Speciality",
                    "kind": "LinkedField",
                    "name": "approaches",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Speciality",
                    "kind": "LinkedField",
                    "name": "areasOfExpertise",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Speciality",
                    "kind": "LinkedField",
                    "name": "trackingOnlySpecialities",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Speciality",
                    "kind": "LinkedField",
                    "name": "clientGroups",
                    "plural": true,
                    "selections": (v3/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfileQuestion",
                "kind": "LinkedField",
                "name": "profileQuestionResponses",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "answer",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileQuestion",
                    "kind": "LinkedField",
                    "name": "profileQuestion",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "translationKey",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "question",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "onboardingStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applicationStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "documentStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profileStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "onboardingApprovedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "applicationApprovedAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "41416d82b542d440d8f05cc6d6328a31",
    "id": null,
    "metadata": {},
    "name": "userRevokeZoomAuthMutation",
    "operationKind": "mutation",
    "text": "mutation userRevokeZoomAuthMutation(\n  $userId: ID!\n) {\n  revokeZoomAccess(userId: $userId) {\n    details {\n      ...userProfileDetailFragment\n      id\n    }\n  }\n}\n\nfragment userProfileApplicationStatusFragment on UserProfileDetailConnect {\n  onboardingStatus\n  applicationStatus\n  documentStatus\n  profileStatus\n  setupCompletedAt\n  onboardingApprovedAt\n  applicationApprovedAt\n}\n\nfragment userProfileDetailFragment on UserProfileDetailConnect {\n  id\n  type\n  roleId\n  profileInformation\n  profileSettings\n  defaultSessionPassword\n  zoomDetails\n  clientLocations\n  preferredVideoType\n  googleCalendarSync\n  signedAgreement\n  setupCompletedAt\n  specialities {\n    approaches {\n      id\n      name\n    }\n    areasOfExpertise {\n      id\n      name\n    }\n    trackingOnlySpecialities {\n      id\n      name\n    }\n    clientGroups {\n      id\n      name\n    }\n  }\n  profileQuestionResponses {\n    id\n    answer\n    profileQuestion {\n      id\n      translationKey\n      question\n    }\n  }\n  ...userProfileApplicationStatusFragment\n}\n"
  }
};
})();

(node as any).hash = "74e92f8c07bc6ef8aeccd68e651160d5";

export default node;
